import React from 'react';
import { ChevronDown } from 'styled-icons/fa-solid/ChevronDown';

import { Flex, AccordionMenu, AccordionMenuContext, TextBox, BaseBox } from 'src/kit';
import { Checkbox } from './Checkbox';

const Toggle = ({ index, label, isHaveSelectedItems }) => {
  const { activeTabIndex } = React.useContext(AccordionMenuContext);
  const isActive = activeTabIndex === index;
  return (
    <Flex colors="textSecondaryToPrimary" alignItems="center" py="20px">
      <TextBox
        textStyle="firstLetter"
        fontWeight={isActive || isHaveSelectedItems ? 'bold' : 'normal'}
        height="14px"
        fontSize={14}
        color={isActive || isHaveSelectedItems ? 'textPrimary' : 'inherit'}
      >
        {label}
      </TextBox>
      <Flex flex="1 0" justifyContent="flex-end">
        <BaseBox
          style={{
            transform: isActive ? 'rotate(180deg)' : 'rotate(0)'
          }}
          as={ChevronDown}
          size={10}
          color="textSecondary"
        />
      </Flex>
    </Flex>
  );
};

export const Filter = ({ index, label, items, id, setFilter, ...props }) =>
  items.length ? (
    <AccordionMenu.AccordionItem index={index}>
      <AccordionMenu.AccordionItemToggle>
        <Toggle
          index={index}
          label={label}
          isHaveSelectedItems={items.map(({ checked }) => checked).filter(Boolean).length}
        />
      </AccordionMenu.AccordionItemToggle>
      <AccordionMenu.AccordionItemContent>
        <Flex className="list-wrapper" flexDirection="column">
          {items.map(item => (
            <Checkbox setFilter={v => setFilter(id, v)} item={item} key={item.label} {...props} />
          ))}
        </Flex>
      </AccordionMenu.AccordionItemContent>
    </AccordionMenu.AccordionItem>
  ) : null;
